import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/syllable-counter")({
  component: SyllableCounterLayout,
});

function SyllableCounterLayout() {
  return <Outlet />;
}
